import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SidePanel from '../../Components/DashBoard/SidePanel/SidePanel';
import UpperPanel from '../../Components/DashBoard/UpperPanel/UpperPanel';
import { ActiveButtonContext } from '../../Contexts/ActiveButtonContext';
import Footer from '../../Components/Footer/Footer';
import AppStudio from '../../Components/AppStudio/AppStudio';
import ApiHub from '../../Components/ApiHub/ApiHub';
import Help from '../../Components/Help/Help';
import { useMsal } from '@azure/msal-react';
import FirstTimeUser from '../../Components/DashBoard/FirstTimeUser/FirstTimeUser';
import envConfig from '../../config/config';

const DashBoardPage = () => {
  const { activeButton, setActiveButton } = useContext(ActiveButtonContext);
  const { activeUrl } = useParams();
  const { accounts } = useMsal();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  const userMail = accounts[0]?.username?.toLowerCase();

  useEffect(() => {
    const addUser = async () => {
      try {
        await fetch(
          `${envConfig.REACT_APP_APIREPO_LOGIN}/apirepo/v0.1/uds/adusers/login`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "localaccountid": accounts[0]?.localAccountId
            },
            body: JSON.stringify({
              username: accounts[0]?.username

            })
          }
        );



      } catch (err) {
        console.error("Error logging in user:", err);
      }
    };

    addUser();
  }, [accounts]);



  useEffect(() => {
    switch (activeUrl) {
      case 'ui_repo':
        setActiveButton('UI Repo');
        break;
      case 'api_repo':
        setActiveButton('API Repo');
        break;
      case 'help':
        setActiveButton('Help');
        break;
      default:
        setActiveButton(null);
    }
  }, [activeUrl, setActiveButton]);

  const AddUsers = useCallback(async (group, unit) => {
    try {
      const adduser = await fetch('https://prod.appstudioltts.com/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          UserName: accounts[0]?.name,
          UserMailID: userMail,
          UserType: "Consumer",
          DeliveryGroup: group,
          DeliveryUnit: unit,
        }),
      });

      if (adduser.ok) sendEmail(userMail);
    } catch {
      console.log("User Already Exists");
    }
  }, [accounts, userMail]);


  const checkUserDetails = useCallback(async () => {
    try {
      const response = await fetch(`https://prod.appstudioltts.com/api/empdata/employees/${userMail}`);
      const data = await response.json();
      const activeData = data.find(item => item["crisp status"] === "Active");

      if (response.ok) {
        await AddUsers(activeData?.DeliveryGroup, activeData?.DeliveryUnit);
      }
    } catch {
      console.log("User Doesn't exist");
    }
  }, [userMail, AddUsers]);


  const sendEmail = async (userMailID) => {
    try {
      const res = await fetch("https://prod.appstudioltts.com/api/logingpage-mail/send-email", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: userMailID }),
      });
      res.ok ? console.log("Email sent successfully.") : console.error("Failed to send email:", res.status);
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  const getUserDetails = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch('https://prod.appstudioltts.com/api/auth', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      const userExists = data.some((user) => user.UserMailID?.toLowerCase() === userMail);
      if (userExists) {
        setUser(userExists);
      } else {
        await checkUserDetails();
      }
    } catch (error) {
      console.error('Error fetching user details:', error);
    } finally {
      setLoading(false);
    }
  }, [userMail, checkUserDetails]);

  useEffect(() => {
    getUserDetails();
  }, [getUserDetails]);

  const renderActiveComponent = () => {
    if (loading) {
      return (
        <div className="flex justify-center items-center h-full">
          <div className="text-lg font-semibold">Loading...</div>
        </div>
      );
    }

    switch (activeButton) {
      case 'UI Repo':
        return <>{!user && <FirstTimeUser setUser={setUser} />}<AppStudio /></>;
      case 'API Repo':
        return <>{!user && <FirstTimeUser setUser={setUser} />}<ApiHub /></>;
      case 'Help':
        return <Help />;
      default:
        return null;
    }
  };

  return (
    <div className='flex flex-col w-full'>
      <div className='flex flex-row flex-grow'>
        <div className="sticky top-0 h-screen w-[13%]">
          <SidePanel />
        </div>
        <div className='flex flex-col flex-grow h-screen overflow-y-auto w-[87%]'>
          <UpperPanel />
          <div className='px-[8px] flex-grow -mt-10 flex flex-col '>
            {renderActiveComponent()}
          </div>
          <div className='sticky bottom-0 z-0'>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoardPage;
